import { gql } from '@apollo/client'

export const CREATE_LEGAL_ADVICE_CASE = gql`
  mutation createLegalAdviceCase(
    $attributes: M2CaseInput!
    $actionAttributes: ActionInput!
    $editorId: ID!
  ) {
    createLegalAdviceCase(
      attributes: $attributes
      actionAttributes: $actionAttributes
      editorId: $editorId
    ) {
      id
      policyholder {
        id
        duplicateEmail
        possibleDuplicate
      }
    }
  }
`
